import SearchIcon from '@mui/icons-material/Search'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import { useEffect, useState } from 'react'
import { IconButton, Toolbar, Tooltip, styled } from '@mui/material'
import { useDebounce } from 'use-debounce'
import { IconFilter, IconBackspace } from '@tabler/icons-react'
import { useIntl } from 'react-intl'
import SuccessModal from '../../../SuccessModal'
import MergeModal from '../../../../views/Leads/components/MergeModal'
import { useDispatch, useSelector } from '../../../../store/store'
import { Search, StyledInputBase } from '../../../../config'
import { setCampaignNameFilterQuerySearch } from '../../../../store/slices/filters/filters'
import { CampaignFilterDrawer } from './campaignFilterDrawer/CampaignFilterDrawer'

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const RemoveSearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const CampaignEnhancedTableToolbar = () => {
  const intl = useIntl()

  const [openMerge, setOpenMerge] = useState(false)
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const { campaignNameFilterQuerySearch } = useSelector((state) => state.filters)
  const [searchValue, setSearchValue] = useState(campaignNameFilterQuerySearch || '')
  const [debouncedSearchValue] = useDebounce(searchValue, 300)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCampaignNameFilterQuerySearch(debouncedSearchValue))
  }, [debouncedSearchValue, dispatch])

  const onMergeSuccess = () => {
    setOpenSuccessModal(true)
  }

  return (
    <>
      <Toolbar>
        <Search sx={{ flex: '1 1 100%', display: 'flex', alignContent: 'baseline' }}>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
            autoFocus
          />
          {campaignNameFilterQuerySearch && (
            <RemoveSearchIconWrapper onClick={() => dispatch(setCampaignNameFilterQuerySearch(''))}>
              <IconBackspace size="24px" className="removeIcon" />
            </RemoveSearchIconWrapper>
          )}
        </Search>
        <Tooltip
          title={intl.formatMessage({ id: 'merge-campaigns' })}
          onClick={() => setOpenMerge(true)}
        >
          <IconButton>
            <AccountTreeIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip onClick={() => setDrawerOpen(!drawerOpen)} title="Filter list">
          <IconButton>
            <IconFilter size="20px" />
          </IconButton>
        </Tooltip>

        <CampaignFilterDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
        {openMerge && (
          <MergeModal open={openMerge} setOpen={setOpenMerge} onMergeSuccess={onMergeSuccess} />
        )}
        <SuccessModal
          successModalOpen={openSuccessModal}
          handleClose={() => setOpenSuccessModal(false)}
          setSuccessModalOpen={setOpenSuccessModal}
          message={intl.formatMessage({ id: 'campaigns-merge-success' })}
        />
      </Toolbar>
    </>
  )
}
